<div
  class="messaging-bubble"
  [ngClass]="{
    'is-filled': isFilled,
    'group-color': type === TYPES.MESSAGE_GROUP,
    'direct-message-color': type === TYPES.MESSAGE_DIRECT,
    'archive-color': type === TYPES.MESSAGE_ARCHIVED
  }"
></div>
